export default "__VITE_ASSET__rRKWbgtU__"